// extracted by mini-css-extract-plugin
var _1 = "Background_wrapper__iikb+";
export { _1 as "wrapper" }
